
import {
  defineComponent,
  onMounted,
  onBeforeUnmount,
  onBeforeMount,
  computed,
} from 'vue';
import IoRouterLink from '@/components/IoRouterLink.vue';
import { useStore } from 'vuex';

export default defineComponent({
  components: {
    IoRouterLink,
  },

  setup() {
    const store = useStore();

    const setPosAndHeight = () => {
      const $wpAdminBar = document.querySelector('#wpadminbar') as HTMLElement;
      const $header = document.querySelector('header') as HTMLElement;
      const $sidebar = document.querySelector('#sidebar') as HTMLElement;

      let top = 0;

      if ($wpAdminBar) {
        top += $wpAdminBar.scrollHeight;
      }
      if ($header) {
        top += $header.offsetHeight;
      }

      if ($sidebar) {
        $sidebar.style.top = `${top}px`;
        $sidebar.style.height = `${window.innerHeight - top}px`;
      }
    };

    onBeforeMount(() => {
      store.dispatch('menus/fetchBySlug', 'sidebar');
    });

    const menuItems = computed(() => store.getters['menus/menu']('sidebar'));
    const menuItemsLoading = computed(() => store.getters['menus/status']('sidebar') === 1);
    const isOpen = computed(() => store.getters['sidebar/open']);

    onMounted(() => {
      window.addEventListener('resize', setPosAndHeight);
      window.addEventListener('load', setPosAndHeight);
      setPosAndHeight();
      for (let i = 100; i < 1000; i += 100) {
        setTimeout(setPosAndHeight, i);
      }
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setPosAndHeight);
      window.removeEventListener('load', setPosAndHeight);
    });

    const toggleSidebar = () => {
      store.dispatch('sidebar/toggle', 'sidebar');
    };

    return {
      menuItems,
      menuItemsLoading,
      isOpen,
      toggleSidebar,
    };
  },
});
